import React, { useState } from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ClearIcon from '@material-ui/icons/Clear'
import grey from '@material-ui/core/colors/grey'
import { useForm } from '../../../providers/FormProvider'

const useStyles = makeStyles((theme) => {
    return {
        pill: {
            padding: '0.5rem 1rem',
            fontSize: '0.8rem',
            textAlign: 'center',
            width: 'max-content',
            borderRadius: '30px',
            backgroundColor: '#fff',
            cursor: 'pointer',
            border: grey[300],
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            '&:hover': {
                backgroundColor: grey[200],
            },
        },
        flex: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        pillName: {},
        icon: {
            fontSize: '1rem',
            paddingRight: '0.5rem',
        },
    }
})

function SelectPill({ name, tagKey }) {
    const classes = useStyles()
    const styles = [classes.pill, classes.flex]
    const { dispatch, formState } = useForm()
    const [selected, setSelected] = useState(formState.tags.includes(tagKey))

    const handleJobSelect = () => {
        if (selected) {
            dispatch({
                type: 'TAGS',
                payload: { type: 'REMOVE', value: tagKey },
            })
            setSelected(false)
            return
        }
        dispatch({ type: 'TAGS', payload: { type: 'ADD', value: tagKey } })
        setSelected(true)
    }

    return (
        <div className={clsx(...styles)} onClick={handleJobSelect}>
            {selected && <ClearIcon className={classes.icon} />}
            <Typography className={classes.pillName}>{name}</Typography>
        </div>
    )
}

export default SelectPill
